import styled from 'styled-components'

import theme from '../theme'

type Props = {
  size?: number
  name: string
}

const Icon = styled.span<Props>`
  display: inline-block;
  font-size: ${(props: Props) => (props.size ? props.size : 20)}px;
  ${theme.icon.default}
  ${(props: Props) => theme.icon.select(props.name)}
`

export default Icon
